import React from 'react';

const NKMobileLogo = () => {
  return (
    <svg
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Night Kitchen Logo"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.5367 4.27586C56.6933 4 54.7803 3.82759 52.8673 3.82759C52.8325 3.82759 52.7977 3.82759 52.7629 3.82759C52.7281 3.82759 52.6934 3.82759 52.6586 3.82759C32.6242 3.82759 16.4159 19.931 16.4159 39.7586C16.4159 39.7931 16.4159 39.8276 16.4159 39.8621C16.4159 39.8965 16.4159 39.931 16.4159 39.9655C16.4159 59.931 32.7286 76.1034 52.8673 76.1034C54.7803 76.1034 56.6933 75.9655 58.5367 75.6552C52.1369 78.8621 44.7283 80.4483 36.9372 79.7931C17.4593 78.2758 1.84227 62.8621 0.137957 43.5517C-1.91417 19.8621 16.868 0 40.3458 0C46.8848 0 53.076 1.55172 58.5367 4.27586Z"
        fill="#EEBF6B"
      />
      <path
        d="M77.5632 51.6895C77.9458 53.1723 78.2589 54.3102 79.0241 54.7585H71.1286C68.7982 44.3102 62.1201 42.3102 62.1201 42.3102V54.7585H54.2246C54.9898 54.2757 55.2681 53.2068 55.2681 51.6551V28.3447C55.2681 26.7585 55.0246 25.6895 54.2246 25.2413H62.1201V35.7585L69.6677 25.2413H78.3632H78.3284C77.8067 25.5861 77.1111 25.7585 76.2067 26.9999L68.0678 37.9309C68.0678 37.9309 75.2676 42.5516 77.5632 51.6895Z"
        fill="#121540"
      />
      <path
        d="M51.7552 53.2068V26.862C51.7552 26.2068 52.0683 25.793 52.6943 25.2413H44.8684V36.2068C44.8684 40.1378 44.8684 40.6551 45.2162 42.9309C44.4858 40.9309 42.9554 39.1723 42.0511 37.5171L34.0513 25.2413H26.7471C27.3731 25.8275 27.6862 26.2068 27.6862 26.862V53.2068C27.6862 53.8275 27.3731 54.3447 26.7471 54.7585H34.6078V43.8964C34.6078 40.5861 34.573 39.5516 34.2599 37.3102C35.0599 39.3792 36.1382 41.0344 36.9729 42.5861L45.5293 54.7585H52.6943C52.103 54.3792 51.7552 53.8275 51.7552 53.2068Z"
        fill="#121540"
      />
    </svg>
  );
};

export default NKMobileLogo;
